export default __webpack_public_path__ + "static/media/Circle_Blood.3a1ac3c4.png";